import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSRichTextTagName: string = 'hhds-richtext';
const TAG_NAME: string = HHDSRichTextTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export class HHDSRichText extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');
		this.setInnerHtml('', '', '<div class="hhds-richtext"><slot></slot></div>');
	}

	override onAttributeChanged(name: string, _oldValue: string, newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Attribute changed: ', name, _oldValue, newValue);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
		if (elements.length == 0) {
			DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Slot emptied');
		} else {
			DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Slot changed');
		}
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
